import { ref } from "vue";

import { router } from "@/router";

const createNavigatingState = () => {
  const isNavigating = ref(false);
  let navigationTimeout: ReturnType<typeof setTimeout> | null = null;

  router.beforeEach(() => {
    // Small delay prevents flash for fast navigations
    navigationTimeout = setTimeout(() => {
      isNavigating.value = true;
    }, 80);
    return true;
  });

  router.afterEach(() => {
    if (navigationTimeout) {
      clearTimeout(navigationTimeout);
      navigationTimeout = null;
    }
    isNavigating.value = false;
  });

  router.onError(() => {
    if (navigationTimeout) {
      clearTimeout(navigationTimeout);
      navigationTimeout = null;
    }
    isNavigating.value = false;
  });

  return { isNavigating };
};

let navigatingState: ReturnType<typeof createNavigatingState> | undefined;

export function useNavigatingState() {
  navigatingState ??= createNavigatingState();
  return navigatingState;
}
